module.exports = __webpack_public_path__ + "assets/img/zh.6922a773.png";